export default "__VITE_ASSET__CZ1frQd9__"